/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  UpdateManyCertificateRequestsMutationRequest,
  UpdateManyCertificateRequestsMutationResponse,
} from "../types/UpdateManyCertificateRequests.ts"

export const updateManyCertificateRequestsMutationKey = () =>
  [{ url: "/v1/certificate-request/update-many-certificate-requests" }] as const

export type UpdateManyCertificateRequestsMutationKey = ReturnType<
  typeof updateManyCertificateRequestsMutationKey
>

/**
 * @description Update many certificate requests
 * @summary Update many certificate requests
 * {@link /v1/certificate-request/update-many-certificate-requests}
 */
export async function updateManyCertificateRequests(
  data: UpdateManyCertificateRequestsMutationRequest,
  config: Partial<
    RequestConfig<UpdateManyCertificateRequestsMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateManyCertificateRequestsMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateManyCertificateRequestsMutationRequest
  >({
    method: "POST",
    url: `/v1/certificate-request/update-many-certificate-requests`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateManyCertificateRequestsMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<UpdateManyCertificateRequestsMutationRequest>
  > & { client?: Client } = {}
) {
  const mutationKey = updateManyCertificateRequestsMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateManyCertificateRequestsMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return updateManyCertificateRequests(data, config)
    },
  })
}

/**
 * @description Update many certificate requests
 * @summary Update many certificate requests
 * {@link /v1/certificate-request/update-many-certificate-requests}
 */
export function useUpdateManyCertificateRequests<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateManyCertificateRequestsMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: UpdateManyCertificateRequestsMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<UpdateManyCertificateRequestsMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateManyCertificateRequestsMutationKey()

  const baseOptions = updateManyCertificateRequestsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateManyCertificateRequestsMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateManyCertificateRequestsMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateManyCertificateRequestsMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateManyCertificateRequestsMutationRequest },
    TContext
  >
}
